"use strict";

$(function(){

  // ==================================================
  // グローバル変数
  // ==================================================

  var deviceFlag;
  var query;
  var queryArray = {};



  // --------------------------------------------------
  // getParam
  // パラメータ取得
  // --------------------------------------------------

  function getParam() {
    if(window.location.search){

      query = window.location.search.substring(1);
      var parms = query.split('&');

      for ( var i=0; i<parms.length; i++ ) {
        var pos = parms[i].indexOf('=');
        var key = parms[i].substring(0,pos);
        var val = parms[i].substring(pos+1);
        queryArray[key] = val;
      }

      if( queryArray['mode'] == 'develop' ) {
        $('body').addClass('is-develop');
      }
    }
  }



  // --------------------------------------------------
  // inviewItem
  // 画面内に要素が入ったときにフェードインさせる
  // --------------------------------------------------

  function inviewItem() {
    $('.js-inviewOnce').on('inview', function() {
      $(this).addClass('is-inview');
    });

    $('.js-inview').on('inview', function(event, isInView){
      if (isInView) {
        $(this).addClass('is-inview');
      } else {
        $(this).removeClass('is-inview');
      }
    });

    $('.c-inviewPos__point').on('inview', function(event, isInView){
      var $parent = $(this).parent('.c-inviewPos');
      $parent.addClass('is-inview');
    });
  }



  // --------------------------------------------------
  // smoothScroll
  // スムーススクロール
  // --------------------------------------------------

  function smoothScroll() {
    $('a[href*="#"]').on('click', function(){

      var speed = 800;

      // ターゲットの要素を取得
      // 「href」属性から「#」移行のみを抽出
      var href = $(this).attr('href');
      var indexOfHash = href.indexOf('#');
      var targetObject = href.substr(indexOfHash);
      var position = $(targetObject).offset().top;

      // グロナビ内のリンクの場合
      if ($(this).parents('.l-header').length) {

        // ページ内に要素があればグロナビを閉じる
        if ($(targetObject).length) {
          $('.l-header__toggle').trigger('click');
        }
      }

      // 自動スクロールアニメーション
      $('html, body').animate({scrollTop:position}, speed, 'easeOutCubic');
      return false;
    });
  }



  // --------------------------------------------------
  // adjustHeight
  // 高さ調整（iOS）
  // --------------------------------------------------

  function adjustHeight() {
    if ($('.js-adjustHeight').length) {
      $('.js-adjustHeight').height(window.innerHeight + 'px');
    }
  }



  // --------------------------------------------------
  // checkGnavHeight
  // グロナビの高さが画面より大きい場合にクラスを付与
  // --------------------------------------------------

  function checkGnavHeight() {
    const windowHeight = $(window).height();
    const gnavHeight = $('.p-gnav').outerHeight();
    const $html = $('html');

    if (gnavHeight > windowHeight) {
      $html.addClass('is-gnav-height-over');
    } else {
      $html.removeClass('is-gnav-height-over');
    }
  }



  // --------------------------------------------------
  // checkCastModalHeight
  // キャストモーダルの内側の高さが画面より大きい場合にクラスを付与
  // --------------------------------------------------

  function checkCastModalHeight() {
    const $modal = $('#js-cast-modal');
    if (!$modal.length) return;

    const $html = $('html');

    if (!$modal.length || !$modal.hasClass('is-show')) {
      $html.removeClass('is-modal-height-over');
      return;
    }

    if ($(window).width() <= 768) {
      $html.removeClass('is-modal-height-over');
      return;
    }

    const windowHeight = $(window).height();
    const contentHeight = $modal.find('.c-modal__cont').outerHeight(true);

    if (contentHeight > windowHeight) {
      $html.addClass('is-modal-height-over');
    } else {
      $html.removeClass('is-modal-height-over');
    }
  }



  // --------------------------------------------------
  // checkModalGoodsHeight
  // グッズモーダルの内側の高さが画面より大きい場合にクラスを付与
  // --------------------------------------------------

  function checkModalGoodsHeight() {
    const $modal = $('#js-goods-modal');
    if (!$modal.length) return;

    const $html = $('html');

    if (!$modal.length || !$modal.hasClass('is-show')) {
      $html.removeClass('is-modal-height-over');
      return;
    }

    if ($(window).width() <= 768) {
      $html.removeClass('is-modal-height-over');
      return;
    }

    const windowHeight = $(window).height();
    const contentHeight = $modal.find('.c-modal__cont').outerHeight(true);

    if (contentHeight > windowHeight) {
      $html.addClass('is-modal-height-over');
    } else {
      $html.removeClass('is-modal-height-over');
    }
  }



  // --------------------------------------------------
  // checkModalBdShopHeight
  // Blu-ray購入モーダルの内側の高さが画面より大きい場合にクラスを付与
  // --------------------------------------------------

  function checkModalBdShopHeight() {
    const $modal = $('#js-bd-shop-modal');
    if (!$modal.length) return;

    const $html = $('html');

    if (!$modal.length || !$modal.hasClass('is-show')) {
      $html.removeClass('is-modal-height-over');
      return;
    }

    if ($(window).width() <= 768) {
      $html.removeClass('is-modal-height-over');
      return;
    }

    const windowHeight = $(window).height();
    const contentHeight = $modal.find('.c-modal__cont').outerHeight(true);

    if (contentHeight > windowHeight) {
      $html.addClass('is-modal-height-over');
    } else {
      $html.removeClass('is-modal-height-over');
    }
  }



  // --------------------------------------------------
  // checkFooterPosition
  // フッターが画面内に入ったらクラスを付与
  // --------------------------------------------------

  function checkFooterPosition() {
    const scrollTop = $(window).scrollTop();
    const windowHeight = $(window).height();
    const footerTop = $('#footer').offset().top;
    const $html = $('html');

    if (scrollTop + windowHeight > footerTop) {
      $html.addClass('is-ticket-on-footer');
    } else {
      $html.removeClass('is-ticket-on-footer');
    }
  }



  // -------------------------------------------------
  // toggleHeader
  // ヘッダー開閉
  // -------------------------------------------------

  function toggleHeader() {
    $('.js-toggle-header').on('click', function(){

      // --------------------------------------------------
      // 閉じるとき
      // --------------------------------------------------
      if ( $('.l-header').hasClass('is-show') ) {
        // $('.l-header').removeClass('is-fadeIn');
        $('.l-header').removeClass('is-show');
        $('html').removeClass('is-fixed-spHeader');

        // setTimeout(function(){
        //   $('.l-header').removeClass('is-show');
        // }, 500);

      // --------------------------------------------------
      // 開くとき
      // --------------------------------------------------
      } else {
        // $('.l-header').addClass('is-show is-fadeIn');
        $('.l-header').addClass('is-show');
        $('html').addClass('is-fixed-spHeader');
      }
    })
  }



  // -------------------------------------------------
  // switchHeroVisual
  // メインビジュアル切替
  // -------------------------------------------------

  function switchHeroVisual() {
    var $hero = $('.p-hero');
    if ($hero.length === 0) return;

    var $visuals = $hero.find('.p-hero__visual-item');
    var $buttons = $hero.find('.p-hero__switch-item');
    var currentIndex = 0;
    var timerId = null;
    var intervalTime = 6000; // ビジュアル切替の時間

    // 表示切替
    function updateVisual(index) {
      $visuals.removeClass('is-active');
      $buttons.removeClass('is-active');
      $visuals.eq(index).addClass('is-active');
      $buttons.eq(index).addClass('is-active');
      currentIndex = index;
    }

    // 自動再生開始
    function startAutoPlay() {
      timerId = setInterval(function() {
        var nextIndex = (currentIndex + 1) % $visuals.length;
        updateVisual(nextIndex);
      }, intervalTime);
    }

    // 自動再生停止
    function stopAutoPlay() {
      if (timerId) {
        clearInterval(timerId);
        timerId = null;
      }
    }

    // ボタンクリックイベント
    $buttons.on('click', function() {
      stopAutoPlay();
      var index = $buttons.index(this);
      updateVisual(index);
    });

    updateVisual(0); // 初期化
    startAutoPlay(); // 自動切替
  }



  // -------------------------------------------------
  // modalCast
  // キャストモーダルの開閉処理
  // -------------------------------------------------

  function modalCast() {
    const $modal = $('#js-cast-modal');
    const $modalInner = $modal.find('.c-modal__inner');
    const $photoList = $('.p-modalCast__list');
    const $items = $('.p-cast__item');
    const $html = $('html');

    if (!$modal.length || !$items.length) return;

    let maxId = 0;
    const roleMap = {};

    $items.each(function() {
      const idStr = $(this).attr('data-modal');
      const idNum = parseInt(idStr, 10);
      const roleText = $(this).find('.p-cast__label-role').text().trim();
      if (idNum > maxId) maxId = idNum;
      roleMap[idStr] = roleText || '拡大写真';
    });

    let listHtml = '';
    for (let i = 1; i <= maxId; i++) {
      const zeroId = ('0' + i).slice(-2);
      const altText = roleMap[zeroId] || '拡大写真';
      listHtml += `
        <li class="p-modalCast__item" data-modal="${zeroId}">
          <img class="p-modalCast__img" src="./assets/img/cast/img_full${zeroId}.jpg" alt="${altText}" width="670" height="1005">
        </li>
      `;
    }
    $photoList.html(listHtml);

    const $photoItems = $('.p-modalCast__item');

    $items.on('click', function() {
      const modalNo = $(this).attr('data-modal');

      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      $html.css('--sw', scrollbarWidth + 'px');

      $photoItems.removeClass('is-current');
      $photoItems.filter(`[data-modal="${modalNo}"]`).addClass('is-current');
      $modalInner.scrollTop(0);
      $modal.addClass('is-show is-fadeIn');
      $html.addClass('is-fixed');

      checkCastModalHeight();
      $modal.find('.p-modalCast__img').one('load', checkCastModalHeight);
    });

    $('.js-modalCast-close').on('click', function() {
      $html.removeClass('is-fixed');
      $modal.removeClass('is-fadeIn');
      setTimeout(function() {
        $modal.removeClass('is-show');
        $photoItems.removeClass('is-current');
        $html.css('--sw', '');
        checkCastModalHeight();
      }, 500);
    });
  }



  // -------------------------------------------------
  // modalMovie
  // 動画モーダルの開閉処理
  // -------------------------------------------------

  function modalMovie() {
    const $modal = $('#js-movie-modal');
    const $startOverlay = $('#js-movie-start-overlay');
    const $items = $('.c-sliderMovie__btn');
    const $html = $('html');
    const fallbackMovieId = "tWlw7vff_Lg"; // 初期値（「公演決定」動画）
    let player = null;


    // 動画モーダルがない場合は処理自体をスキップ
    if (!$modal.length) return;


    // ------------------------------
    // CMS
    // ------------------------------

    // CMS要素の存在確認
    const $dataContainer = $('#js-movie-initialMovieId');
    let initialMovieId = '';
    let shouldAutoShow = false;

    // CMS入力内容の精査
    if ($dataContainer.length) {
      const $iframe = $dataContainer.find('iframe');
      const src = $iframe.attr('src');

      if ($iframe.length && src && src.indexOf('embed/') !== -1) {
        // iframeがあり、かつYouTubeのURLである場合
        const startIndex = src.indexOf('embed/') + 6;
        initialMovieId = src.substr(startIndex, 11);

        if (initialMovieId.length === 11) {
          // 正常：IDが11文字取れた場合
          shouldAutoShow = true;
        } else {
          // 軽微なミス：IDが不完全な場合はフォールバックを適用して表示
          initialMovieId = fallbackMovieId;
          shouldAutoShow = true;
        }
      }
      // 判定が終わったので、データソースとしてのiframeは削除
      $iframe.remove();
    }

    // アンカーリンク付きURLでは自動表示をスキップ（例: /#schedule, /#ticket）
    if (window.location.hash && window.location.hash.length > 1) {
      shouldAutoShow = false;
    }



    // ------------------------------
    // 動画プレイヤー生成
    // ------------------------------

    const initPlayer = function () {
      player = new YT.Player('js-movie-player', {
        height: '360',
        width: '640',
        videoId: shouldAutoShow ? initialMovieId : '',
        playerVars: {
          'autoplay': 0,
          'mute': 0,
          'rel': 0,
          'playsinline': 1
        },
        events: {
          'onReady': function () {
            if (shouldAutoShow) {
              $modal.addClass('is-show is-fadeIn');
              $html.addClass('is-fixed');
            }
          }
        }
      });
    };



    // ------------------------------
    // YouTube IFrame APIのロード
    // ------------------------------

    if (window.YT && window.YT.Player) {
      // 既にAPIがロードされている場合は即実行
      initPlayer();
    } else {
      // まだロードされていない場合は準備完了時のコールバックに登録
      window.onYouTubeIframeAPIReady = initPlayer;

      // APIスクリプトが未挿入の場合のみ挿入
      if (!$('script[src*="youtube.com/iframe_api"]').length) {
        const tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      }
    }



    // ------------------------------
    // 音声付き再生のためのオーバーレイクリック
    // ------------------------------

    $startOverlay.on('click', function () {
      $(this).hide();
      if (player && typeof player.playVideo === 'function') {
        player.playVideo();
      }
    });



    // ------------------------------
    // MOVIEのサムネイル画像クリックで動画切替
    // ------------------------------

    $items.on('click', function () {
      const movieId = $(this).data('movie-id');

      // 切り替え時はオーバーレイを隠し、即時再生（またはロード）
      $startOverlay.hide();
      $modal.addClass('is-show is-fadeIn');
      $html.addClass('is-fixed');

      if (player && typeof player.loadVideoById === 'function') {
        player.loadVideoById(movieId);
      }
    });



    // ------------------------------
    // 動画モーダルを閉じる
    // ------------------------------

    $('.js-modalMovie-close').on('click', function () {
      $html.removeClass('is-fixed');
      $modal.removeClass('is-fadeIn');

      if (player && typeof player.stopVideo === 'function') {
        player.stopVideo();
      }

      setTimeout(function () {
        $modal.removeClass('is-show');
        $startOverlay.show();
      }, 500);
    });
  }



  // -------------------------------------------------
  // modalGoods
  // グッズモーダル
  // -------------------------------------------------

  const GOODS_MODAL_ITEM_ID_PARAM = 'goods-modal-item-id';
  const GOODS_MODAL_ITEM_ID_PATTERN = /^\d+$/;

  function getGoodsModalItemIdFromQuery() {
    const raw = queryArray[GOODS_MODAL_ITEM_ID_PARAM];
    if (!raw || !GOODS_MODAL_ITEM_ID_PATTERN.test(raw)) {
      return null;
    }
    return raw;
  }

  function findGoodsModalListItem(id) {
    return $('.js-modalGoods-open').filter(function () {
      return $(this).attr('data-goods-modal-item-id') === id;
    });
  }

  function modalGoods() {
    const $modal = $('#js-goods-modal');
    const $modalInner = $modal.find('.c-modal__inner');
    const $box = $modal.find('.c-modal__box');
    const $html = $('html');

    if (!$modal.length) return;

    function openGoodsModalFromListItem($li) {
      const tplEl = $li.find('template').get(0);
      if (!tplEl || !tplEl.content) {
        return;
      }

      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      $html.css('--sw', scrollbarWidth + 'px');

      $modalInner.scrollTop(0);
      $box.empty();
      $box[0].appendChild(tplEl.content.cloneNode(true));

      $modal.addClass('is-show is-fadeIn');
      $html.addClass('is-fixed');

      checkModalGoodsHeight();
      $box.find('img').one('load', checkModalGoodsHeight);
    }

    $('.js-modalGoods-open').on('click', function () {
      openGoodsModalFromListItem($(this));
    });

    const itemId = getGoodsModalItemIdFromQuery();
    if (itemId) {
      const $target = findGoodsModalListItem(itemId);
      if ($target.length) {
        openGoodsModalFromListItem($target.first());
      }
    }

    $('.js-modalGoods-close').on('click', function () {
      $html.removeClass('is-fixed');
      $modal.removeClass('is-fadeIn');
      setTimeout(function () {
        $modal.removeClass('is-show');
        $html.css('--sw', '');
        $box.empty();
        checkModalGoodsHeight();
      }, 500);
    });

    $modal.on('click', '.p-modalGoods__thumb-item', function () {
      const $item = $(this);
      const $goods = $item.closest('.p-modalGoods');
      const index = $goods.find('.p-modalGoods__thumb-item').index($item);

      $goods.find('.p-modalGoods__main-item, .p-modalGoods__thumb-item').removeClass('is-current');
      $goods.find('.p-modalGoods__main-item').eq(index).addClass('is-current');
      $item.addClass('is-current');
    });
  }



  // -------------------------------------------------
  // modalBdShop
  // Blu-ray購入モーダル
  // -------------------------------------------------

  const BD_SHOP_MODAL_ITEM_ID_PARAM = 'bd-shop-modal-item-id';
  const BD_SHOP_MODAL_ITEM_ID_PATTERN = /^\d+$/;

  function getBdShopModalItemIdFromQuery() {
    const raw = queryArray[BD_SHOP_MODAL_ITEM_ID_PARAM];
    if (!raw || !BD_SHOP_MODAL_ITEM_ID_PATTERN.test(raw)) {
      return null;
    }
    return raw;
  }

  function findBdShopModalTrigger(id) {
    return $('.js-modalBdShop-open').filter(function () {
      return $(this).attr('data-bd-shop-modal-item-id') === id;
    });
  }

  function modalBdShop() {
    const $modal = $('#js-bd-shop-modal');
    const $modalInner = $modal.find('.c-modal__inner');
    const $box = $modal.find('.c-modal__box');
    const $html = $('html');

    if (!$modal.length) return;

    function openBdShopModalFromTrigger($trigger) {
      const tplEl = $trigger.find('template').get(0);
      if (!tplEl || !tplEl.content) {
        return;
      }

      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      $html.css('--sw', scrollbarWidth + 'px');

      $modalInner.scrollTop(0);
      $box.empty();
      $box[0].appendChild(tplEl.content.cloneNode(true));

      $modal.addClass('is-show is-fadeIn');
      $html.addClass('is-fixed');

      checkModalBdShopHeight();
      $box.find('img').one('load', checkModalBdShopHeight);
    }

    $('.js-modalBdShop-open').on('click', function () {
      openBdShopModalFromTrigger($(this));
    });

    const itemId = getBdShopModalItemIdFromQuery();
    if (itemId) {
      const $target = findBdShopModalTrigger(itemId);
      if ($target.length) {
        openBdShopModalFromTrigger($target.first());
      }
    }

    $('.js-modalBdShop-close').on('click', function () {
      $html.removeClass('is-fixed');
      $modal.removeClass('is-fadeIn');
      setTimeout(function () {
        $modal.removeClass('is-show');
        $html.css('--sw', '');
        $box.empty();
        checkModalBdShopHeight();
      }, 500);
    });
  }



  // --------------------------------------------------
  // replaceSVG
  // imgタグのSVGをインラインSVGに置換
  // --------------------------------------------------

  function replaceSVG() {
    // 各img要素にdata-src属性でSVGファイルのパスを指定
    $('img.js-replaceSVG').each(function(index, element) {
      var svgPath = $(element).data('src');
      // SVGファイルを取得
      $.get(svgPath, function(data) {
        // 取得したSVGの内容をimgタグにセット
        var inlineSVG = new XMLSerializer().serializeToString(data.documentElement);
        $(element).replaceWith(inlineSVG);
      }, 'xml');
    });
  }



  // --------------------------------------------------
  // widthCheck
  // 画面サイズのチェック
  // --------------------------------------------------

  function widthCheck() {
    var winWidth = $(window).width();

    // 画面幅768以下でフラグがspでない時
    if (winWidth <= 768 && deviceFlag != 'sp') {
      deviceFlag = 'sp';

      // 画面幅768よりおおきく、フラグがpcでない時
    } else if (winWidth > 768 && deviceFlag != 'pc') {
      deviceFlag = 'pc';
    }
  }



  // --------------------------------------------------
  // setWidth
  // 画像の横幅を自動で設定
  // --------------------------------------------------

  function setWidth() {
    if($('.js-setWidth').length) {
      $('.js-setWidth').each(function(){
        var style = $(this).attr('style');

        // 未設定のものにだけ適用する
        if (!style || !style.includes('width')) {
          var width = $(this).attr('width');
          $(this).attr('style', 'width: '+width+'rem');
        }
      });
    }
  }



  // --------------------------------------------------
  // sliderMovie
  // MOVIEスライダー
  // --------------------------------------------------

  function sliderMovie() {
    if ($('.c-sliderMovie').length) {
      $('.c-sliderMovie').slick({
        slidesToShow: 1,    // 表示枚数
        slidesToScroll: 1,  // 1回でスライドする枚数
        infinite: false,    // ループ再生
        autoplay: false,    // 自動再生
        arrows: true,       // 矢印
        dots: true,         // ドット
        touchThreshold: 100 // 低いフリック距離で切り替わるよう感度を調整
      });
    }
  }



  // --------------------------------------------------
  // removeNewsListItems
  // 指定IDのニュース記事を非表示
  // --------------------------------------------------

  function removeNewsListItems() {
    var hiddenIds = ['1133663'];

    $('.c-newsList__item').each(function () {
      var $item = $(this);
      var href = $item.find('.c-newsList__link').attr('href');
      if (!href) return;

      for (var i = 0; i < hiddenIds.length; i++) {
        if (href.indexOf('id=' + hiddenIds[i]) === -1) continue;

        $item.before(document.createComment(' remove '));
        $item.remove();
        return;
      }
    });
  }



  // ==================================================
  // 即時
  // ==================================================

  removeNewsListItems();
  setWidth();
  getParam();
  adjustHeight();
  toggleHeader();
  modalCast();
  sliderMovie();
  modalMovie();
  modalGoods();
  modalBdShop();
  adjustHeight();
  smoothScroll();
  inviewItem();
  switchHeroVisual();



  // ==================================================
  // 画像読み込み後
  // ==================================================

  $(window).on('load', function(){
    replaceSVG();
  });



  // ==================================================
  // リサイズ、スクロール時の処理
  // ==================================================

  var timer = null;

  $(window).on('load resize scroll', function(){
    clearTimeout(timer);
    timer = setTimeout(function() {

      // 高さ調整
      adjustHeight();

      // グロナビの高さチェック
      checkGnavHeight();

      // キャストモーダルの高さチェック
      checkCastModalHeight();

      // グッズモーダルの高さチェック
      checkModalGoodsHeight();

      // Blu-ray購入モーダルの高さチェック
      checkModalBdShopHeight();

      // フッターの位置チェック
      checkFooterPosition();
    }, 10);
  });



  // --------------------------------------------------
  // リサイズ時
  // --------------------------------------------------

  $(window).on('load resize',function() {

    // 横幅確認（PC・SP振り分け）
    widthCheck();
  });

});